import type { BaseQueryFn, FetchArgs, QueryReturnValue, FetchBaseQueryError, FetchBaseQueryMeta } from "@reduxjs/toolkit/query"
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_API_BASE_URL}/${import.meta.env.VITE_API_VERSION}`,
  prepareHeaders: (headers: Headers) => {
    if (!headers.has("Accept")) {
      headers.set("Accept", "application/json")
    }

    const accept_language = localStorage.getItem("i18nextLng")?.split("-")[0] || "en"
    if (!headers.has("Accept-Language") && accept_language) {
      headers.set("Accept-Language", accept_language)
    }

    if (!headers.has("X-TransOutputType")) {
      headers.set("X-TransOutputType", "text")
    }

    return headers
  }
})

const baseQueryWithConfig: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  let response: QueryReturnValue<any, FetchBaseQueryError, FetchBaseQueryMeta>

  const config = (api.getState() as any).api.queries["getConfig(undefined)"]?.data

  if (config) {
    response = await baseQuery(
      typeof args === "string"
        ? args
        : {
          ...args,
          headers: {
            ...args.headers,
            "X-Tenant": config.tenant,
            "X-CompanyID": config.company_id,
          },
        },
      api,
      extraOptions
    )
  } else {
    response = await baseQuery(args, api, extraOptions)
  }

  return response
}

export const apiSlice = createApi({
  baseQuery: baseQueryWithConfig,
  endpoints: (build) => ({
    getConfig: build.query<any, void>({
      query: () => ({
        url: "/gift-cards/config/public",
        method: "GET",
      }),
    }),
    getTranslations: build.query<any, { language: string; namespace: string }>({
      query: ({ language, namespace }) => ({
        url: `/translations/niki.${namespace}`,
        method: "GET",
        headers: {
          "Accept-Language": language,
        },
      }),
    }),
  }),
})

export const {
  useGetConfigQuery,
  useGetTranslationsQuery,
} = apiSlice
